export default {
   setToken: (state,payload) => {
      state.token = payload;
   },
   setPermissions: (state,payload) => {
      state.permissions = payload;
   }
}